<template>
    <div>
        <van-sticky>
            <div
                id="commonTop"
                :class="{'header':true,'headerDark':isDark}"
                :style="{'height':'88px'}"
            >
                <i v-if="true || isJHApp" class="return" @click="returnTop"></i>
                {{hide ? enterPlan ? titleSan : titleTwo : title}}
                <span v-if="isDownload" class="download" @click="download"></span>
                <slot></slot>
            </div>
        </van-sticky>
    </div>
</template>

<script>
import { isAndroid } from "@/utils/base";
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "commonHeader",
    props: ["title", "isDownload", 'hide', 'titleTwo', 'enterPlan', 'titleSan', 'prohibit'],
    data () {
        return {
            show: false,
            isAndroid: isAndroid()
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    methods: {
        download () {
            this.$v.appCheckUpdate()
        },
        returnTop () {
            if (this.isAndroid === 1) {
                jsbridg.closeWebview()
            } else {
                jsbridg.goBack()
            }
            // if (this.prohibit) {
            //     return
            // }
            // if (this.enterPlan) {
            //     this.$emit("update:enterPlan", false)
            //     return
            // }
            // if (this.hide) {
            //     this.$emit("update:hide", false)
            //     return
            // }
            // // this.$v.appPageQuit()
            // window.history.go(-1)
        }
    }
}
</script>

<style scoped lang="less">
    .header{
        position: relative;
        text-align: center;
        font-size:16px;
        font-weight:400;
        background-color: #fff;
        color:#000;
        overflow: hidden;
        .help{
            width: 15px;
            height: 15px;
            background-image: url("../../assets/img/match/vote/help.png");
            background-size: cover;
            z-index: 1;
            position: absolute;
            right: 16px;
            bottom: 16px;
        }
        .return{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 45px;
            height: 45px;
            background-image: url("../../assets/img/common/backBlack.png");
            background-size: cover;
            z-index: 1;
        }
        .download{
            position: absolute;
            right: 0;
            bottom: 0;
            width: 45px;
            height: 45px;
            background-image: url("../../assets/img/common/downloadHeader.png");
            background-size: cover;
            z-index: 1;
        }
    }
    .hasBorder{
        border-bottom: 1px solid #E8E8E8;
    }
    .headerDark{
        background-color: #121212;
        color: #FFFFFF;
        .return{
            background-image: url("../../assets/img/common/backLight.png");
        }
    }
</style>
